import React, { createContext, useContext, useState } from "react";

// Upload Context 創建
const ClientContext = createContext();

// 提供者組件
export const ClientProvider = ({ children }) => {
  const [clientData, setClientData] = useState({
    house: "",
    client_zh: "",
    client_en: "",
    client_alias: "",
    tax_no: "",
    phone: "",
    address: "",
    contact_name: "",
    contact_phone: "",
    contact_email: "",
    date: "",
    payment_terms: "",
  });


  const [clientStatus, setClientStatus] = useState(""); // 用於管理上傳狀態

  // 提供更新函數，支持局部更新
  const updateClientData = (fieldOrData, value) => {
    if (typeof fieldOrData === "object") {
      // 更新整個對象
      setClientData((prev) => ({
        ...prev,
        ...fieldOrData,
      }));
    } else {
      // 單個欄位更新
      setClientData((prev) => ({
        ...prev,
        [fieldOrData]: value,
      }));
    }
    // console.log(clientData);
  };
  
  return (
    <ClientContext.Provider value={{ 
        clientData, 
        updateClientData,
        clientStatus, // 確保上傳狀態被傳入
        setClientStatus, // 確保更新狀態的函數被傳入
         }}>
      {children}
    </ClientContext.Provider>
  );
};

// 自定義 Hook
export const useClientContext = () => useContext(ClientContext);
